import { render, staticRenderFns } from "./SupplyChainProvinceSalesRanking.vue?vue&type=template&id=4f326ee3&scoped=true&"
import script from "./SupplyChainProvinceSalesRanking.vue?vue&type=script&lang=js&"
export * from "./SupplyChainProvinceSalesRanking.vue?vue&type=script&lang=js&"
import style0 from "./SupplyChainProvinceSalesRanking.vue?vue&type=style&index=0&lang=less&"
import style1 from "./SupplyChainProvinceSalesRanking.vue?vue&type=style&index=1&id=4f326ee3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f326ee3",
  null
  
)

export default component.exports